import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-plano',
  templateUrl: './sessao-plano.component.html',
  styleUrls: ['./sessao-plano.component.scss']
})
export class SessaoPlanoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
